import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  LabelList,
} from "recharts";

import {
  _formatNumber,
  _formatPrice,
} from "../../../../../../shared/helpers/utils";

const CustomBarChart = ({ theme, data , height=200, noSpecialCharacter=false, isPrice=false, }) => {
  // Find the maximum value for dynamic Y-axis range
  const maxValue = Math.max(...data.map((item) => item.value));

  // Format the Y-axis ticks as prices
  const formatter = (tickValue) => {
    if(isPrice) return tickValue === 0 ? '' : _formatPrice(tickValue);
    return tickValue === 0 ? '' : tickValue ;
     // Assuming _formatPrice formats numbers as "$1,000"
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} barCategoryGap={10} margin={{ top: 20, right: 10, left: 0, bottom: 20 }}>
        {/* X-Axis */}
        <XAxis
          dataKey="name"
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 500,
          }}
          
        />
        {/* Y-Axis */}
        {/*<YAxis
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          domain={[0, maxValue]}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 500,
          }}
          tickFormatter={formatter}
        /> */}
        {/* Bars */}
        <Bar
          dataKey="value"
          className="bar-element-chart"
          barSize={90} // Increase this value for thicker bars
          radius={[0, 0, 0, 0]} // Rounded corners on top
          barGap={4} 
          fill={theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)"}
        >
          {/* Value above the bar */}
          <LabelList
            dataKey="value"
            position="top"
            formatter={(value) => isPrice ? `$${_formatNumber(value)}` : _formatNumber(value)} 
            className="bar-chart-label-outside"
            style={{
              fontSize: 20,
              fontWeight: 500
            }}
          />

        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
